import React, { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/shadcn-ui/popover";
import { Button } from "../../components/shadcn-ui/button";
import { Menu, X } from "lucide-react";
import { dashBoardOptions } from "../../pages/dashboard/dashBoardOption";
import { Card, CardContent } from "../../components/shadcn-ui/card";
import { Link } from "react-router-dom";
import { PermissionNavItem } from "features/Permission/PermissionNavItem";
import { EmiCalculator } from "features/emiCalculator/EmiCalculator";

export const FloatingButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = () => setIsOpen(!isOpen);

  const handleOptionClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div className="absolute left-0 right-0 bottom-0 top-0 z-10 bg-black bg-opacity-50"></div>
      )}
      <div className="fixed z-50 md:flex flex-col items-center bottom-16 right-0 ">
        <Popover open={isOpen} onOpenChange={handleToggle}>
          <PopoverTrigger asChild>
            <Button
              onClick={handleToggle}
              className="md:hidden w-14 h-14 rounded-full bg-gray-500 text-white flex items-center justify-center rounded-tr-none rounded-br-none"
            >
              {isOpen ? <X /> : <Menu size={34} />}
            </Button>
          </PopoverTrigger>
          {isOpen && (
            <>
              <PopoverContent className="flex bg-transparent border-none flex-col space-y-4 shadow-none rounded-lg p-4 z-20 relative right-4 bottom-2 items-end">
                {dashBoardOptions.map((props) => (
                  <PermissionNavItem
                    key={props.linkTo}
                    requiredPermissions={props.requiredPermissions}
                  >
                    <FloatingButtonOption
                      {...props}
                      handleClick={handleOptionClick}
                    />
                  </PermissionNavItem>
                ))}
                <EmiCalculator
                  floatingCard
                  handleOptionClick={handleOptionClick}
                />
              </PopoverContent>
            </>
          )}
        </Popover>
      </div>
    </>
  );
};

export interface FloatingButtonOptionProps {
  linkTo: string;
  title: string;
  icon: string;
  bgColor: string;
  handleClick?: () => void;
}

const FloatingButtonOption = ({
  linkTo,
  title,
  icon,
  bgColor,
  handleClick,
}: FloatingButtonOptionProps) => {
  return (
    <Link to={linkTo} onClick={handleClick}>
      <Card className={`${bgColor} flex items-center px-3 py-2 w-fit`}>
        <img src={`${icon}`} alt="" style={{ height: "24px" }} />
        <CardContent className="p-0 ml-4">{title}</CardContent>
      </Card>
    </Link>
  );
};
